// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"265":"97f3546a99a7bfe4","271":"83b6f508a5a53811","446":"7f9a90c9f1804b04","755":"013da668f9cda24f","795":"d8ad4f0cd6b4f70e","821":"477f8a05e175cce5"}[chunkId] + ".js";
};